module.exports = __webpack_public_path__ + "img/360_step_5.d8bcdddb.png";